import React, { FC } from "react";

export const MyFarmerIcon: FC = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.25" cy="20" r="20" fill="#BF83FF" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.25 16C22.25 18.2091 20.4591 20 18.25 20C16.0409 20 14.25 18.2091 14.25 16C14.25 13.7909 16.0409 12 18.25 12C20.4591 12 22.25 13.7909 22.25 16ZM18.25 21C14.384 21 11.25 23.2386 11.25 26C11.25 27.1046 12.1454 28 13.25 28H23.25C24.3546 28 25.25 27.1046 25.25 26C25.25 23.2386 22.116 21 18.25 21ZM26.25 14C26.8023 14 27.25 14.4477 27.25 15V16H28.25C28.8023 16 29.25 16.4477 29.25 17C29.25 17.5523 28.8023 18 28.25 18H27.25V19C27.25 19.5523 26.8023 20 26.25 20C25.6977 20 25.25 19.5523 25.25 19V18H24.25C23.6977 18 23.25 17.5523 23.25 17C23.25 16.4477 23.6977 16 24.25 16H25.25V15C25.25 14.4477 25.6977 14 26.25 14Z"
        fill="white"
      />
    </svg>
  );
};
